var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { FlowDirectionItem } from './flow-direction.item';
import { FlowDirectionType } from './flow-direction-type';
import { LocalizationHelper } from '../../../../../shared/helpers/localization-helper';
import { AppConsts } from '../../../../../shared/AppConsts';
var FlowDirectionService = /** @class */ (function () {
    function FlowDirectionService(localizationService) {
        this.localizationService = localizationService;
        this.flowDirectionList = [
            new FlowDirectionItem(FlowDirectionType.Positive, this.l('PositiveDirection')),
            new FlowDirectionItem(FlowDirectionType.Negative, this.l('NegativeDirection'))
        ];
    }
    FlowDirectionService.prototype.getFlowDirection = function () {
        return this.flowDirectionList;
    };
    FlowDirectionService.prototype.l = function (value) {
        return LocalizationHelper.l(this.localizationService, AppConsts.localization.configureLocalizationSourceName, value);
    };
    FlowDirectionService = __decorate([
        Injectable()
    ], FlowDirectionService);
    return FlowDirectionService;
}());
export { FlowDirectionService };
